// frontend(root)/src/services/apiService.js
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000';

// Create an axios instance with default config
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Activity feed related API calls
export const activityApi = {
  // Get activity feed with filters
  getActivityFeed: async (filter = 'all', page = 1, limit = 20) => {
    try {
      const response = await api.get(`/api/activities?filter=${filter}&page=${page}&limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching activity feed:', error);
      throw error;
    }
  },
  
  // Get a specific user's activity
  getUserActivity: async (userId, page = 1, limit = 20) => {
    try {
      const response = await api.get(`/api/activities/user/${userId}?page=${page}&limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching user (${userId}) activity:`, error);
      throw error;
    }
  },
  
  // Delete an activity
  deleteActivity: async (activityId) => {
    try {
      const response = await api.delete(`/api/activities/${activityId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting activity:', error);
      throw error;
    }
  }
};

export default api;